import {
  CallScribeCallStatus,
  CallScribeConsentResult,
  ICallScribeCallListItem,
} from 'services/callScribe/types';

export const NotRecordedReason = {
  CallNotAnswered: 'CallNotAnswered',
  CustomerOptedOut: 'CustomerOptedOut',
  TechnicianRecordingDisabled: 'TechnicianRecordingDisabled',
  CustomerDeclined: 'CustomerDeclined',
  ConsentNotEstablished: 'ConsentNotEstablished',
  RecordingPending: 'RecordingPending',
  CaptureFailed: 'CaptureFailed',
} as const;

export type TNotRecordedReason = typeof NotRecordedReason[keyof typeof NotRecordedReason];

export const NO_SUMMARY_GENERIC = 'No summary was produced for this call.';

export const NOT_CONNECTED_BODY = 'Nobody answered, so there is nothing to transcribe.';

export const notRecordedBody = (
  reasonText: string | null | undefined,
  notConnected: boolean,
): string => {
  const served = (reasonText ?? '').trim();
  if (served.length > 0) {
    return served;
  }
  return notConnected ? NOT_CONNECTED_BODY : NO_SUMMARY_GENERIC;
};

export const offersRecheck = (
  reason: string | null | undefined,
  notConnected: boolean,
): boolean => {
  if (reason === null || reason === undefined || reason === '') {
    return !notConnected;
  }
  return reason === NotRecordedReason.RecordingPending;
};

export const DECLINED_NO_SUMMARY =
  'Not recorded: the customer declined recording, so there is no transcript or summary.';

const NEVER_CONNECTED: Partial<Record<CallScribeCallStatus, string>> = {
  [CallScribeCallStatus.Completed]: 'Nobody answered this call, so there is no transcript or summary.',
  [CallScribeCallStatus.NoAnswer]: 'Nobody answered this call, so there is no transcript or summary.',
  [CallScribeCallStatus.Busy]: 'The line was busy, so there is no transcript or summary.',
  [CallScribeCallStatus.Failed]: 'The call did not go through, so there is no transcript or summary.',
  [CallScribeCallStatus.Cancelled]:
    'The call was cancelled before anyone answered, so there is no transcript or summary.',
};

export const noSummarySentence = (
  call: Pick<ICallScribeCallListItem, 'consentResult' | 'status' | 'answeredAtUtc' | 'notRecordedReason' | 'notRecordedReasonText'>,
): string | null => {
  if (call.consentResult === CallScribeConsentResult.Declined) return DECLINED_NO_SUMMARY;
  if (!call.answeredAtUtc) {
    const sentence = NEVER_CONNECTED[call.status];
    if (sentence) return sentence;
  }
  const served = (call.notRecordedReasonText ?? '').trim();
  if (served && call.notRecordedReason && call.notRecordedReason !== NotRecordedReason.RecordingPending) {
    return served;
  }
  return null;
};
